// extracted by mini-css-extract-plugin
export default {"link":"TK-z","disabled":"UK-z"};